import Category from '@/components/v2/business/category/category';
import {HomeGameCardItem, HomeGameFloorItem} from '../home.type';
import React, {FC, useEffect, useMemo, useRef, useState} from 'react';
import CasinoGamesCard from '@/components/v2/business/category/casino-games-card';
import styles from './hot.module.scss';
import {Image} from 'antd-mobile';
import {useRequest} from 'ahooks';

import {getBetBy, getGameURL, getHomeGames} from '../home.service';
import {debounce, getUrlParams, goTo} from '@/utils';
import {toAllCasinoGame} from '@/common-pages/game-navigate';
import NoData from '@/components/basic/error-pages/no-data';
import Spin from '@/components/v2/basic/spin';
import globalStore from '@/services/global.state';
import {useBetByInit} from '@/utils/betby';
import {
  getLotteryGames,
  LotteryGameCardItem,
  LotteryGameFloorItem,
} from '@/common-pages/lottery/lottery.service';
import MixLotteryCard from '@/components/v2/business/category/mix-lotto-card';
import {jumpStateLottery} from '@/common-pages/lottery/lottery-content';
// import {homePage} from '@/config';

export function renderCategory(
  category: HomeGameFloorItem,
  onTab?: (tabkey: string) => void,
) {
  const getSportURL = debounce((gametype: string) => {
    globalStore.globalLoading.next(true);
    getGameURL(gametype)
      .then((url: string) => {
        globalStore.openSports.next({
          type: gametype,
          name: gametype.split('_')[0].toUpperCase() + ' Sports',
          url,
        });
      })
      .catch(e => {
        const {log} = console;
        log('error', e);
      })
      .finally(() => globalStore.globalLoading.next(false));
  });
  const renderItem = (item: HomeGameCardItem) => {
    switch (category.uniqueKey) {
      case 'hotGames':
      case 'ClassicGames':
      case 'liveCasinoV2':
      case 'casinoV2':
        return (
          <CasinoGamesCard
            onClick={() => toAllCasinoGame(item.id)}
            width="7rem"
            height="9.25rem"
            key={item.id}
            pic={item.gamePic}
            title={item.name}
            // odds={item.odds}
            desc={item.provider}
            onlyPic
          />
        );
      case 'Slots':
      case 'Provider':
        return (
          <div
            key={item.id}
            className="px-3.5 py-2 flex items-center justify-center bg-card rounded"
            onClick={() => goTo('Providers', {provider: item.provider})}>
            <Image src={item.gamePic} height="1.5rem" />
          </div>
        );
      case 'original':
        return (
          <CasinoGamesCard
            onClick={() => toAllCasinoGame(item.id)}
            width="7rem"
            height="9.25rem"
            key={item.id}
            hasDesc={false}
            title={item.name}
            pic={item.gamePic}
            onlyPic
          />
        );
      case 'fishing':
        return (
          <CasinoGamesCard
            onClick={() => toAllCasinoGame(item.id)}
            width="7rem"
            height="9.25rem"
            key={item.id}
            hasDesc={false}
            title={item.name}
            pic={item.gamePic}
            onlyPic
          />
        );
      case 'sports':
        return (
          <div
            key={item.id}
            className="relative h-[6rem] flex flex-row items-center justify-end rounded-lg overflow-hidden"
            onClick={() => getSportURL(item.gameUrl)}>
            <Image
              src={item.gamePic}
              width={'auto'}
              height={'6rem'}
              className="absolute top-0 left-0"
            />
          </div>
        );
      default:
        return <div key={item.id} />;
    }
  };
  const itemSpan = (item: HomeGameCardItem) => {
    return item.picPlaceholder || 1;
  };
  const tabkeyMap: Record<string, string> = {
    ClassicGames: 'Classic',
    original: 'Original',
    liveCasinoV2: 'Live Casino',
    casinoV2: 'Casino',
    lotteryV2: 'Lottery',
    fishing: 'Fishing',
  };

  let gameList: HomeGameCardItem[] = category.gamesList || [];

  let row = 1,
    col = 3,
    className,
    desc,
    footer,
    contentPaddingPosition: 'content' | 'slider' = 'slider',
    onAll =
      category.uniqueKey === 'hotGames'
        ? () => goTo('Casino')
        : () =>
            tabkeyMap[category.uniqueKey]
              ? onTab?.(tabkeyMap[category.uniqueKey])
              : goTo('Casino');
  switch (category.uniqueKey) {
    case 'Slots':
    case 'Provider':
      row = 3;
      col = 3;
      className = 'slots-category';
      onAll = () => goTo('Providers');
      contentPaddingPosition = 'content';
      break;
    case 'sports':
      col = category.gamesList?.length && category.gamesList.length > 1 ? 2 : 1;
      contentPaddingPosition = 'content';
      break;
  }

  return gameList?.length ? (
    <Category
      key={category.id}
      icon={category.categoryPic}
      title={category.name}
      list={gameList}
      onAll={onAll}
      total={
        ['sports'].includes(category.uniqueKey)
          ? undefined
          : category.gamesList?.length || 0
      }
      row={row}
      col={col}
      headerDesc={desc}
      className={className ? styles[className] : undefined}
      renderItem={renderItem}
      itemSpan={itemSpan}
      // sliderSize={sliderSize}
      footer={footer}
      contentPaddingPosition={contentPaddingPosition}
    />
  ) : null;
}

function renderSports(category: HomeGameFloorItem) {
  return (
    <Category
      key={'betby-widget-sports'}
      icon={category.categoryPic}
      title={category.name}
      list={[{id: 'betby-widget-sports'}]}
      row={1}
      col={1}
      renderItem={item => (
        <div key={item.id} id={item.id} className="w-full relative z-[1]" />
      )}
      contentPaddingPosition="no-padding"
    />
  );
}

function useLotteryV2Render(lotteryV2Item?: HomeGameFloorItem) {
  const [stateLottery, setStateLottery] = useState<LotteryGameFloorItem>();
  useEffect(() => {
    if (!lotteryV2Item) {
      return;
    }
    const hasStateLottery = lotteryV2Item.gamesList.some(game =>
      game.name.toLowerCase().includes('state lottery'),
    );
    if (!hasStateLottery) {
      return;
    }
    getLotteryGames()
      .then(games => {
        const mixLotteryItem = games.find(
          game => game.uniqueKey === 'indianLottery',
        );

        if (mixLotteryItem) {
          const gameList = mixLotteryItem.gamesList.sort(
            (a, b) =>
              +(b?.otherParams || '').split('stopTime=')[1] -
              +(a?.otherParams || '').split('stopTime=')[1],
          );
          mixLotteryItem.gamesList = gameList;
          setStateLottery(mixLotteryItem);
        }
      })
      .catch(e => {
        const {log} = console;
        log('error', e);
      });
  }, [lotteryV2Item]);

  const headerList = useMemo(() => {
    return lotteryV2Item?.gamesList.filter(
      game => !game.name.toLowerCase().includes('state lottery'),
    );
  }, [lotteryV2Item]);

  const jumpGame = (v: HomeGameCardItem) => {
    if (
      v.name.toLowerCase() === 'dice game' ||
      v.gameType.toLowerCase() === 'dice'
    ) {
      const params = getUrlParams(v.gameUrl);
      params.cycle = 1;
      goTo('Dice', params);
    } else if (
      v.name.toLowerCase() === 'wingo' ||
      v.gameType.toLowerCase() === 'color'
    ) {
      goTo('Color', {...getUrlParams(v.otherParams), name: v.name});
    } else if (v.gameType.toLowerCase() === 'quick 3d') {
      goTo('Digit', {
        pickGameType: 'quick',
        // cycle: item.cycle,
      });
    } else if (v.name.toLowerCase() === 'state lottery') {
      goTo('Lottery');
    }
  };

  const renderItem = (item: LotteryGameCardItem, index?: number) => {
    return (
      <MixLotteryCard
        key={item.id}
        data={item}
        index={index || 0}
        onClick={() => jumpStateLottery(item)}
      />
    );
  };

  return lotteryV2Item ? (
    <Category
      key={lotteryV2Item?.id}
      icon={lotteryV2Item?.categoryPic}
      title={lotteryV2Item?.name}
      list={stateLottery?.gamesList || []}
      total={stateLottery?.gamesList.length || 0}
      onAll={() => goTo('Lottery')}
      row={1}
      col={2}
      slidesPerView={2}
      contentPaddingPosition="slider"
      renderContentHeader={
        headerList?.length ? (
          <div className="grid grid-cols-3 gap-2 px-3">
            {headerList.map(item => (
              <CasinoGamesCard
                onClick={() => jumpGame(item)}
                height="9.25rem"
                key={item.id}
                hasDesc={false}
                title={item.name}
                pic={item.gamePic}
                onlyPic
              />
            ))}
          </div>
        ) : undefined
      }
      renderItem={renderItem}
    />
  ) : null;
}

interface HotContentProps {
  onTab?: (tabkey: string) => void;
}

const HotContent: FC<HotContentProps> = ({onTab}) => {
  const {data, loading} = useRequest(getHomeGames);
  const widgetRef = useRef<any>();

  const handleInitBetbyWidget = () => {
    if (widgetRef.current != null) {
      return;
    }
    const itemdiv = document.getElementById('betby-widget-sports');
    if (!itemdiv) {
      return;
    }
    console.log('itemdiv', itemdiv);
    getBetBy().then(res => {
      widgetRef.current = new BTRenderer().initialize({
        // Brand id
        brand_id: res.brandId,
        // User token
        token: res.token,
        // Language
        lang: 'en',
        // Dom node for widget
        target: itemdiv,
        // Optional theme override,
        // should not be set if you want to use your
        // default brand theme
        themeName: 'default',
        // Widget name:
        widgetName: 'promo',
        // Params specific to widget
        widgetParams: {
          // placeholder name from backoffice
          placeholder: 'operator_page1',
          // callback to change url when user clicks on banner
          onBannerClick: (args: any) => {
            console.log('banner click', args);
            if (!login) {
              goTo('Login');
            }
            goTo('BetBy', {
              'bt-path': args.url,
            });
          },

          withSportsList: true,
          // callback to change url when user clicks on sport icon within sports menu
          onSportClick: (args: any) => {
            console.log('sports click', args);
            if (!login) {
              goTo('Login');
            }
            goTo('BetBy', {
              'bt-path': args.url,
            });
            // goTo('BetBy', {})
          },
        },
      });
    });
  };

  const {login} = useBetByInit(handleInitBetbyWidget);
  // const rSports = useMemo(() => {
  //   return renderSports({
  //     id: 1,
  //     name: 'Sports',
  //     categoryPic: 'https://cdn.betby.com/images/sports.png',
  //     uniqueKey: 'sports',
  //     gamesList: [],
  //   });
  // }, []);
  const lotteryV2Render = useLotteryV2Render(
    data?.find(item => item.uniqueKey === 'lotteryV2'),
  );
  return (
    <Spin loading={loading}>
      {!loading && !!data && !!data.length ? (
        data.map(item =>
          item.uniqueKey === 'sports'
            ? item.gamesList?.length > 0
              ? renderSports(item)
              : null
            : item.uniqueKey === 'lotteryV2'
            ? lotteryV2Render
            : renderCategory(item, onTab),
        )
      ) : (
        <div className="h-[18rem]">
          <NoData />
        </div>
      )}
    </Spin>
  );
};

export default HotContent;
